import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import {NavLink} from 'react-router-dom'
import {routesUrls} from '../../settings/routes'


const Submenu = (props, context) => {
    let {formatMessage} = context
    return (
        <div className="text-center">
            <NavLink
                className = {cn([
                    "btn btn-block fairy-button",
                ])}
                activeClassName = ""
                to = {routesUrls.dashboard}
                exact
            >{formatMessage(`backToMainPage`)}</NavLink>
        </div>
    )
}
Submenu.contextTypes = {formatMessage: PropTypes.any}


export default Submenu


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/NotFound/Submenu.js